// extracted by mini-css-extract-plugin
export default {"textContainer":"productPage_textContainer__ukeLV"};